<template>
  <div style="padding-bottom: 80px">
    <b-card
      no-body
      class="mb-2"
    >
      <hr class="my-0">
      <div class="p-2">
        <b-row>
          <b-col
            v-if="items.length > 0"
          >
            <h5>Dados do Arquivo Importado:</h5>
            <b-table 
              ref="table"
              class="pb-2"
              :items="items"
              :fields="fields"
              caption-top
              responsive
              sticky-header="400px"
            >
              <template #cell(numero)="item">
                {{ item.index + 1 }}
              </template>
              <template #cell(editar)="data">
                <div 
                  class="d-flex justify-content-center" 
                  style="min-height: 45px;"
                >
                  <b-button 
                    v-if="!data.item[0].loading && !data.item[0].gerado && data.item[0].campos.length > 0"
                    class="text-secondary"
                    variant="link"
                    @click="openModal(data.item)"
                  >
                    <feather-icon
                      icon="Edit3Icon"
                      size="18"
                    />
                  </b-button>
                </div>
              </template>
              <template #head(selecionar)="{}">
                <div class="d-flex justify-content-center">
                  <b-checkbox
                    v-model="allSelected"
                    @change="value => selectAll(value, items)"
                  />
                </div>
              </template>
              <template #cell(selecionar)="data">
                <div class="d-flex justify-content-center">
                  <b-checkbox
                    v-model="data.item[0].selecionado"
                    :disabled="!data.item[0].valido || data.item[0].loading || data.item[0].gerado"
                    @change="selecionaEtiqueta($event, data.item, data.index)"
                  />
                </div>
              </template>
              <template #cell(valido)="data">
                <div class="d-flex justify-content-center">
                  <span 
                    :id="`tooltip-target-${data.index}`"
                    :class="data.item[0].valido ? 'text-success' : 'text-danger'"
                  >
                    <feather-icon
                      :icon="data.item[0].valido ? 'CheckCircleIcon' : 'XIcon'"
                      size="18"
                    />
                  </span>
                  <b-tooltip 
                    :target="`tooltip-target-${data.index}`"
                    triggers="hover"
                  >
                    <span>
                      {{ data.item[0].valido ? 'Dados válidos' : '' }}
                    </span>
                    <ul
                      v-if="!data.item[0].valido"
                      class="pl-1 pt-1 m-0 text-left"
                    >
                      <li
                        v-for="(erro, index) in data.item[0].erros"
                        :key="index"
                        class="pb-1"
                      >
                        {{ erro }}
                      </li>
                    </ul>
                  </b-tooltip>
                </div>
              </template>
              <template #cell(gerado)="data">
                <div class="d-flex justify-content-center">
                  <span 
                    :id="`tooltip-target-gerado-${data.index}`"
                    :class="data.item[0].gerado && !data.item[0].erroApi ? 'text-success' : (data.item[0].erroApi ? 'text-danger' : '')"
                  >
                    <b-spinner 
                      v-if="data.item[0].loading" 
                      style="width: 1.5rem; height: 1.5rem;"
                    />
                    <feather-icon
                      v-if="!data.item[0].loading"
                      :class="data.item[0].gerado && !data.item[0].erroApi ? 'text-success' : (data.item[0].erroApi ? 'text-danger' : '')"
                      :icon="data.item[0].gerado && !data.item[0].erroApi ? 'CheckCircleIcon' : (data.item[0].erroApi ? 'XIcon' : 'MoreHorizontalIcon')"
                      size="18"
                    />
                  </span>
                  <b-tooltip 
                    :target="`tooltip-target-gerado-${data.index}`"
                    triggers="hover"
                  >
                    <span>
                      {{ data.item[0].gerado ? 'Etiqueta gerada' : 'Não gerado' }}
                    </span>
                    <ul
                      v-if="data.item[0].erroApi"
                      class="pl-1 pt-1 m-0 text-left"
                    >
                      <li
                        v-for="(erro, index) in data.item[0].erros"
                        :key="index"
                        class="pb-1"
                      >
                        {{ erro }}
                      </li>
                    </ul>
                  </b-tooltip>
                </div>
              </template>
              <template #cell(pudo)="data">
                <div 
                  class="d-flex justify-content-center" 
                >
                  <b-button 
                    class="text-secondary"
                    variant="link"
                    @click="openModalPickUp(data)"
                  >
                    <span v-if="data.item[0].etiqueta.pudoId"> {{ data.item[0].etiqueta.pudoId }}</span>
                    <feather-icon
                      v-else
                      icon="SearchIcon"
                    />
                  </b-button>
                </div>
              </template>
              <template #cell(apagar)="data">
                <div 
                  class="d-flex justify-content-center" 
                  style="min-height: 45px;"
                >
                  <b-button 
                    v-if="!data.item[0].valido || data.item[0].gerado"
                    class="text-secondary"
                    variant="link"
                    @click="removerEtiquetaDaLista(data)"
                  >
                    <feather-icon
                      icon="TrashIcon"
                      size="18"
                    />
                  </b-button>
                </div>
              </template>
            </b-table>
          </b-col>
          <b-col
            v-if="items.length == 0"
          >
            <h5>Não há dados</h5>
          </b-col>
        </b-row>
      </div>
      <hr class="my-0">
      <div class="p-2">
        <b-row class="flex-row-reverse">
          <div
            style="display:flex; align-items: center; justify-content: center;"
          >
            <span 
              v-if="linhasComErro > 0"
              class="text-danger mr-2"
            >
              <feather-icon
                class="text-danger"
                icon="AlertTriangleIcon"
                size="18"
              />
              Existe {{ linhasComErro }} objetos que precisam ser editados. Caso você clique em Gerar Etiqueta, serão geradas somente as etiquetas que não precisam ser ajustadas
              <feather-icon
                class="text-danger"
                icon="AlertTriangleIcon"
                size="18"
              />
            </span>
            <b-button
              v-if="items.length > 0"
              variant="primary"
              class="mb-sm-0 mr-0 mr-sm-1"
              :block="$store.getters['app/currentBreakPoint'] === 'xs'"
              type="submit"
              :disabled="importacao.loading"
            >
              Gerar etiquetas
              <feather-icon
                v-if="!importacao.loading"
                class="ml-1"
                icon="CheckIcon"
              />
              <b-spinner 
                v-if="importacao.loading"
                class="ml-1"
                style="width: 1rem; height: 1rem;"
              />
            </b-button>
            <b-button
              v-else
              variant="secondary"
              class="mb-sm-0 mr-0 mr-sm-1"
              :block="$store.getters['app/currentBreakPoint'] === 'xs'"
              @click="goBack"
            >
              Voltar
            </b-button>
          </div>
        </b-row>
      </div>
    </b-card>
    <b-modal
      id="modal-campos"
      ref="modal"
      title="Editar Campos"
      cancel-title="Cancelar"
      ok-title="OK"
      size="xl"
      style="max-height: 10000px"
      @show="resetModal"
      @hidden="resetModal"
      @ok="handleOk($event, salvaDadosCampos)"
    >
      <validation-observer
        ref="validatorCamposModal"
      >
        <b-form
          ref="formModalCampos"
          @reset.prevent="resetForm"
        >
          <editar-dados-importacao 
            :get-validation-state="getValidationState"
            :item.sync="modalData"
          />
        </b-form>
      </validation-observer>
    </b-modal>
    <b-modal
      id="modal-pickup"
      ref="modalPudo"
      title="Pick up"
      cancel-title="Cancelar"
      ok-title="OK"
      size="md"
      style="max-height: 5000px"
      @cancel="resetModal"
      @ok="handleOkPudo(salvaDadoCamposPudo, modalPudoData)"
    >
      <b-form
        ref="formModalCampos"
        @reset.prevent="resetForm"
      >
        <pickup-modal
          :cep-dest.sync="modalPudoCep"
          :data.sync="modalPudoData"
        />
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import store from '@/store'
import { watch, reactive, ref, toRefs } from '@vue/composition-api'
import { createNamespacedHelpers } from 'vuex-composition-helpers'
import swal from 'sweetalert2/dist/sweetalert2.min'
import { $themeConfig } from '@themeConfig'
import pickupModal from '@/views/envios/components/pickup-modal.vue'
import EditarDadosImportacao from '../../../components/editarDadosImportacao'

const appLoading = $themeConfig.app.appLoadingImage

export default {
  name: 'DadosImportacao',
  components: { EditarDadosImportacao, pickupModal },
  props: {
    getValidationState: {
      type: Function,
      required: true,
    },
    importacao: {
      type: undefined,
      required: true,
    },
    goBack: {
      type: Function,
      required: true,
    },
  },

  setup(props) {
    const dadosArquivoStore = createNamespacedHelpers('arquivoImportacao')
    const layoutStore = createNamespacedHelpers('layout')
    const clienteLayoutParametroStore = createNamespacedHelpers('clienteLayoutParametro')
    const etiquetaStore = createNamespacedHelpers('etiqueta')
    const etiquetaStoreAction = etiquetaStore.useActions(['delete']).delete

    const modal = ref(null)
    const modalPudo = ref(null)

    const state = reactive({
      dadosArquivo: dadosArquivoStore.useGetters(['dadosArquivo']).dadosArquivo,
      layout: layoutStore.useGetters(['layout']).layout,
      layoutParametros: clienteLayoutParametroStore.useGetters(['layoutParametros']).layoutParametros,
      items: [],
      fields: [],
      allSelected: true,
      modalData: {},
      modalPudoCep: null,
      modalPudoData: null,
      camposBackup: [],
      etiquetas: [],
      linhasComErro: 0,
    })

    watch(() => state.dadosArquivo, value => {
      state.fields = []
      state.items = []
      state.modalData = {}
      state.camposBackup = []
      state.etiquetas = []
      state.allSelected = true
      state.linhasComErro = 0
      Object.values(value.linhasObjeto).forEach((linha, index) => {
        state.etiquetas.push(linha.etiqueta)
        const campos = []
        campos.push({
          numero: index,
          selecionado: false,
          valido: linha.valido,
          erros: linha.erros,
          gerado: false,
          erroApi: false,
          loading: false,
          campos: linha.campos,
          etiqueta: linha.etiqueta,
        })
        linha.campos.forEach(campo => {
          campos.push(campo.conteudo)
        })
        state.items.push(campos)
        props.importacao.items.push(null)
        if (!linha.valido) {
          state.linhasComErro += 1
        }
      })
      state.fields.push({ label: 'Número', key: 'numero' })
      state.fields.push({ label: 'Editar', key: 'editar' })
      state.fields.push({ label: 'Selecionar', key: 'selecionar' })
      state.fields.push({ label: 'Válido', key: 'valido', formatter: (_val, _key, item) => (item[0].valido ? 2 : 1), sortable: true, sortByFormatted: true })
      state.fields.push({ label: 'Gerado', key: 'gerado', formatter: (_val, _key, item) => (item[0].gerado ? 2 : 1), sortable: true, sortByFormatted: true })
      if (state.etiquetas[0].servicoId === 40) {
        state.fields.push({ label: 'Buscar PickUp', key: 'pudo', tdClass: 'text-nowrap', thStyle: { whiteSpace: 'nowrap' } })
      }
      Object.values(value.header).forEach((header, index) => { 
        state.fields.push({ label: header, key: `${index + 1}`, sortable: true, tdClass: 'text-nowrap', thStyle: { minWidth: '250px', whiteSpace: 'nowrap' } })
      })
      state.fields.push({ label: 'Apagar', key: 'apagar' })
    })

    const openModal = item => {
      const itensModal = { ...item }
      itensModal[0].campos = itensModal[0].campos.filter(c => c.parametro != null)
      state.modalData = item
      state.camposBackup = []
      itensModal[0].campos.forEach(campo => {
        state.camposBackup.push(campo.conteudo)
      })
      modal.value.show()
    }

    const openModalPickUp = data => {
      const { clienteId } = data.item[0].etiqueta
      const { cep } = data.item[0].etiqueta.destinatario
      appLoading.show()

      store.dispatch('pickup/findPickUps', { clienteId, cep }).finally(() => {
        appLoading.hide()
        state.modalPudoCep = cep
        state.modalPudoData = data
        modalPudo.value.show()
      })
    }

    const salvaDadosCampos = () => {
      const { campos, numero } = state.modalData[0]
      const etiqueta = state.etiquetas[numero]
      campos.forEach((campo, index) => {
        const pudoError = state.items[numero][0].erros.find(itemErro => !itemErro.includes('O campo pudo precisa ser selecionado'))
        if (pudoError) {
          state.modalData[0].valido = true
        }
        state.modalData[0].campos[index].conteudo = campo.conteudo
        state.modalData[0].campos[index].msgErro = null
        state.modalData[index + 1] = campo.conteudo
        state.items[numero][0].campos[index].conteudo = campo.conteudo
        state.camposBackup[index] = campo.conteudo
        const prop = campo.parametro.nomeCampoEtiqueta.split('.')
        if (prop.length > 1) {
          etiqueta[prop[0]][prop[1]] = campo.conteudo
        } else {
          etiqueta[prop[0]] = campo.conteudo
        }
      })
      state.linhasComErro -= 1
    }

    const salvaDadoCamposPudo = () => {
      const { item } = state.modalPudoData
      const indexPudo = item.indexOf('Pudo') - 1
      item[0].erros = item[0].erros.filter(itemErro => !itemErro.includes('O campo pudo precisa ser selecionado'))
      if (item[0].erros.length === 0) {
        item[0].valido = true
      }
      const dataPudo = item[0].campos[indexPudo]
      dataPudo.conteudo = item[0].etiqueta.pudoId
      dataPudo.msgErro = null
      dataPudo.valido = true
      state.linhasComErro -= 1
    }

    const removerDaLista = etqIndex => {
      state.items = state.items.filter((_, index) => index !== etqIndex)
      state.items.forEach((item, index) => {
        item[0].numero = index
      })
      state.etiquetas = state.etiquetas.filter((_, index) => index !== etqIndex)
      state.linhasComErro = state.items.filter(item => item[0].valido === false).length
      props.importacao.items = props.importacao.items.filter((_, index) => index !== etqIndex)
    }

    const removerEtiquetaDaLista = etq => {
      swal.fire({
        title: 'Atenção!',
        icon: 'warning',
        html: 'Você tem certeza que quer deletar essa etiqueta?',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        showCancelButton: true,
        cancelButtonText: 'Não',
        confirmButtonText: 'Sim, eu tenho!',
        buttonsStyling: false,
      }).then(result => {
        if (result.isConfirmed) {
          if (state.etiquetas[etq.index].arquivoEmailId) {
            etiquetaStoreAction(state.etiquetas[etq.index].arquivoEmailId).then(() => {
              removerDaLista(etq.index)
            })
          } else {
            removerDaLista(etq.index)
          }
        }
      })
    }

    const resetModal = () => {
      state.modalData[0].campos.forEach((campo, index) => {
        campo.conteudo = state.camposBackup[index]
      })
    }
    
    return {
      ...toRefs(state),
      modal,
      modalPudo,
      openModal,
      salvaDadosCampos,
      salvaDadoCamposPudo,
      resetModal,
      removerEtiquetaDaLista,
      openModalPickUp,
    }
  },
  watch: {
    items() {
      this.selectAll(true, this.items)
    },
  },
  methods: {
    selectAll(value, items) {
      if (!value) {
        for (let x = 0; x < this.importacao.items.length; x += 1) {
          this.importacao.items.splice(x, 1, null)
        }
      }
      items.forEach((item, index) => {
        if (item[0].valido && !item[0].loading && !item[0].gerado) {
          item[0].selecionado = value
          if (value) {
            this.importacao.items.splice(index, 1, item)
          }
        }
      })
    },
    selecionaEtiqueta(event, item, index) {
      if (event) {
        const indexARemover = this.importacao.items[index] ? 0 : 1
        this.importacao.items.splice(index, indexARemover, item)
      } else {
        this.importacao.items.splice(index, 1, null)
      }
    },
    async validaCamposModal() {
      const validation = this.$refs.validatorCamposModal
      const valid = await validation.validate()
      return valid
    },
    handleOk(bvModalEvent, salvaDadosCampos) {
      bvModalEvent.preventDefault()
      this.validaCamposModal().then(valid => {
        if (valid) {
          salvaDadosCampos()
          this.$nextTick(() => {
            this.$bvModal.hide('modal-campos')
            this.$refs.table.refresh()
          })
        }
      })
    },
    handleOkPudo(salvaDadoCamposPudo, modalPudoData) {
      if (modalPudoData.item[0].etiqueta.pudoId) {
        salvaDadoCamposPudo()
        this.$nextTick(() => {
          this.$bvModal.hide('modal-pickup')
          this.$refs.table.refresh()
        })
      }
    },
  },
}
</script>